<template>
	<Layout :pageTitle="title" :backlink="`/events`">
		<template #cta>
			<div v-if="item" class="d-flex">
				<EventInvitePromotor :eventId="item.id" ref="eventInvitePromotor" />

				<b-dropdown no-caret right class="dropdown-dots">
					<template v-slot:button-content><i class="icon icon-dot-3"></i></template>
					<b-dropdown-item @click="$refs.eventInvitePromotor.open()" v-if="item.status == 'ACTIVE'">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							class="icon icon-tabler icon-tabler-user-plus mr-2"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							stroke-width="2"
							stroke="currentColor"
							fill="none"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
							<circle cx="9" cy="7" r="4"></circle>
							<path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
							<path d="M16 11h6m-3 -3v6"></path>
						</svg>
						Invitar promotor RRPP
					</b-dropdown-item>
					<b-dropdown-item :to="`/events/${item.id}/update`" v-if="item.status != 'ENDED'">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							class="icon icon-tabler icon-tabler-pencil mr-2"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							stroke-width="2"
							stroke="currentColor"
							fill="none"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
							<path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
							<line x1="13.5" y1="6.5" x2="17.5" y2="10.5"></line>
						</svg>
						Editar</b-dropdown-item
					>
					<b-dropdown-item @click="deletePrompt(item)" class="delete-item" v-if="item.status == 'PENDING'">
						<i class="icon icon-trashcan"></i> Eliminar
					</b-dropdown-item>
				</b-dropdown>
			</div>
		</template>

		<template #head v-if="item">
			<EventDetailHeader :eventId="item.id" />
			<ul class="nav nav-tabs " v-if="item">
				<li class="nav-item">
					<router-link
						tag="a"
						:to="`/events/${item.id}`"
						:class="{ active: !tab || tab == '' }"
						class="nav-link"
						>Dashboard</router-link
					>
				</li>
				<li class="nav-item">
					<router-link
						tag="a"
						:to="`/events/${item.id}/memberships`"
						:class="{ active: tab == 'memberships' }"
						class="nav-link"
						>Membresias</router-link
					>
				</li>
				<li class="nav-item">
					<router-link
						tag="a"
						:to="`/events/${item.id}/ticketGroups`"
						:class="{ active: tab == 'ticketGroups' }"
						class="nav-link"
						>Tipos de entradas</router-link
					>
				</li>
				<li class="nav-item">
					<router-link
						tag="a"
						:to="`/events/${item.id}/publishing`"
						:class="{ active: tab == 'publishing' }"
						class="nav-link"
						>Publicación</router-link
					>
				</li>
				<li class="nav-item">
					<router-link
						tag="a"
						:to="`/events/${item.id}/tickets`"
						:class="{ active: tab == 'tickets' }"
						class="nav-link"
						>Tickets</router-link
					>
				</li>
				<li class="nav-item">
					<router-link
						tag="a"
						:to="`/events/${item.id}/access`"
						:class="{ active: tab == 'access' }"
						class="nav-link"
						>Accesos</router-link
					>
				</li>
			</ul>
		</template>

		<Loader :show="loading" type="inline" />

		<div class="main-container container" v-if="!loading && item">
			<div class="row row-xs">
				<div class="col-12  py-3">
					<div v-if="!tab">
						<div class="px-2">
							<EventDashboard :eventId="item.id" />
						</div>
					</div>

					<div v-if="tab == 'memberships'">
						<div class="px-2">
							<h5 class="mb-0">Membresias</h5>
							<p class="text-secondary">
								Elige que membresias puede acceder a este evento.
							</p>

							<EventMemberships :eventId="item.id" />
						</div>
					</div>

					<div v-if="tab == 'ticketGroups'">
						<div class="px-2">
							<EventTicketGroups :eventId="item.id" :canCreate="true" />
						</div>
					</div>

					<div v-if="tab == 'publishing'">
						<div class="px-2">
							<EventPublishing :eventId="item.id" />
						</div>
					</div>

					<div v-if="tab == 'tickets'">
						<div class="px-2">
							<EventTicketSellsTable :eventId="item.id" />
						</div>
					</div>

					<div v-if="tab == 'access'">
						<div class="px-2">
							<div class="d-flex justify-content-between align-items-center">
								<h5 class="mb-0">Registro de accesos</h5>
								<div class="filters-box justify-content-between">
									<div class="filter">
										<div class="filter-input">
											<i class="icon icon-search"></i>
											<input
												type="text"
												class="form-control"
												placeholder="Buscar en accesos"
												v-model="filters.search"
												@keyup.enter="updateFilters($event)"
											/>
											<div
												class="btn btn-light btn-clear-filter"
												v-if="filters.search"
												@click="
													filters.search = null
													updateFilters()
												"
											>
												<i class="icon icon-close"></i>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="card">
								<div class="card-body">
									<EventAccessTable :eventId="item.id" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"
import EventDetailHeader from "./EventDetailHeader"
import EventTicketGroups from "./EventTicketGroups"
import EventMemberships from "./EventMemberships"
import EventDashboard from "./EventDashboard"
import EventTicketSellsTable from "./EventTicketSellsTable"
import EventAccessTable from "./EventAccessTable"
import EventPublishing from "./EventPublishing"
import EventInvitePromotor from "./forms/EventInvitePromotor"

export default {
	name: "EventDetail",
	components: {
		EventDetailHeader,
		EventTicketGroups,
		EventDashboard,
		EventMemberships,
		EventTicketSellsTable,
		EventAccessTable,
		EventInvitePromotor,
		EventPublishing
	},
	data() {
		return {
			item: null,
			title: "Detalle de evento",
			loading: false,
			tab: null
		}
	},
	async beforeMount() {
		this.filters = this.getValidUrlParams()
		if (!this.$route.params.id) this.$router.push(-1)
		await this.load()
		this.tab = this.$route.params.tab || null
	},
	methods: {
		async load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							event(id: $id) {
								id
								code
								name
								startAt
								endAt
								description
								image {
									id
									type
									filename
									url
									urlThumb
								}
								location {
									id
									name
									locality {
										name
										region {
											name
										}
									}
									address
									latlng {
										lat
										lng
									}
								}
								ticketGroups {
									id
									name
									ticketsLimit
									minPerOrder
									maxPerOrder
									validAt
									ticketTypes {
										id
										name
										ticketsLimit
										priceUnit
									}
								}
								status
								statusText
								statusClass
								canEdit
							}
						}
					`,
					variables: { id: this.$route.params.id },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.loading = false
					this.item = data.event
					return data.event
				})
				.catch(() => {})
		},

		deletePrompt() {
			this.$dialog
				.confirm(
					{
						title: "Eliminar evento",
						body: `¿Está seguro que desea eliminar el evento "<strong>${this.item.name}"</strong>?`
					},
					{
						okText: "Eliminar",
						customClass: "delete-prompt"
					}
				)
				.then(() => {
					this.delete()
				})
		},

		delete() {
			this.loading = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!) {
							eventDelete(id: $id) {
								id
							}
						}
					`,
					variables: {
						id: this.item.id
					}
				})
				.then(() => {
					this.$toast.success("Evento eliminado correctamente")
					this.$router.push("/events")
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.event-head {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: 0px;

	.image {
		width: 100px;
		height: 100px;
		border-radius: 8px;
		background-color: #eee;
		background-size: cover;
		background-position: center;
		margin-right: 1rem;
	}

	.data {
		padding: 0x 16px;

		.badge {
			border-radius: 3px;
			display: inline-block;
			padding: 1px 8px;
			font-weight: 500;
			// background-color: rgb(255, 241, 233);
			// color: rgb(212, 48, 2);
			font-size: 12px;
			line-height: 20px;
			margin-bottom: 4px;
		}

		h1 {
			margin-bottom: 0px;
			font-weight: 600;
			font-size: 24px;
			line-height: 32px;
		}
		.description {
			strong {
				font-weight: 500;
			}
		}
	}
}

.main-image {
	width: 100%;
	padding-bottom: 40%;
	border-radius: 8px;
	background-size: cover;
	background-position: center;
	margin-bottom: 12px;
}

.icons i {
	color: #888;
}

.nav-tabs {
	border-bottom: none;
}
</style>
